<div class="modal-dialog" role="document">
  <div class="modal-content bd-0">
    <div class="modal-header pd-y-20 pd-x-25">
      <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{ passedData.title | translate }}</h6>
      <button type="button" class="btn-close" (click)="dialogRef.close(false);" aria-label="Sluiten"></button>
    </div>

    <div class="modal-body p-5">
      @if (isUnused) {
        <p class="mg-b-5">{{ 'LOCATIONS.FILTER-GROUPS.CONFIRM-DELETION.BODY.UNUSED' | translate: { name: passedData.friendlyName } }}</p>
      } @else {
        @if (venueUsages.length > 0) {
          <p class="mg-b-5">{{ 'LOCATIONS.FILTER-GROUPS.CONFIRM-DELETION.BODY.USED-IN-VENUE' | translate: { name: passedData.friendlyName } }}</p>
          <ul class="usage-list">
            @for (usage of venueUsages; track usage) {
              <li class="usage-list-item">{{ usage.Name }}</li>
            }
          </ul>
        }
        @if (eventUsages.length > 0) {
          <p class="mg-b-5">{{ 'LOCATIONS.FILTER-GROUPS.CONFIRM-DELETION.BODY.USED-IN-EVENT' | translate: { name: passedData.friendlyName } }}</p>
          <ul class="usage-list">
            @for (usage of eventUsages; track usage) {
              <li class="usage-list-item">{{ usage.EventStartDateTime | localDateTime }} &ndash; {{ usage.Name }}</li>
            }
          </ul>
        }
      }
    </div>

    <div class="modal-footer">
      <div class="col-6">
        <button type="button" class="btn btn-block btn-primary" (click)="dialogRef.close(true)">{{ 'BTN.OK' | translate }}</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-block btn-secondary" (click)="dialogRef.close(false);">{{ 'BTN.CANCEL' | translate }}</button>
      </div>
    </div>

  </div>
</div>
